<form-section [subtitle]="subtitle(13333)">
    <form-item>
        <form-text [alignLeft]="true" [subtitle]="subtitle(1132)"></form-text>
        <form-text
                [subtitle]="settingsAccount.accountInformation.accountName"></form-text>
    </form-item>
    <form-value-button [subtitle]="subtitle(3391)"
                       [value]="settingsAccount.accountInformation.accountEmail"
                       (onClick)="openDialog('email')">
    </form-value-button>
    <form-card-button [subtitle]="subtitle(1949)"
                      (onClick)="openDialog('password')">
    </form-card-button>
    <form-card-button [danger]="true"
                      [subtitle]="subtitle(3806)"
                      (onClick)="openDialog('deleteAccount')">
    </form-card-button>
</form-section>

@if (forms.isCompanySubdomain('kolton')) {
    <form-section [subtitle]="subtitle(2972)">
        <form-card-button [subtitle]="subtitle(2972)"
                          (onClick)="openDialog('additionalInfo')">
        </form-card-button>
        <form-item>
            <form-label [label]="subtitle(7162)"></form-label>
            <form-text [subtitle]="forms.contactForm.city"></form-text>
        </form-item>
        <form-item>
            <form-label [label]="subtitle(7161)"></form-label>
            <form-text [subtitle]="forms.contactForm.street"></form-text>
        </form-item>
        <form-item>
            <form-label [label]="subtitle(7163)"></form-label>
            <form-text [subtitle]="forms.contactForm.houseNumber"></form-text>
        </form-item>
        <form-item>
            <form-label [label]="subtitle(4697)"></form-label>
            <form-text [subtitle]="forms.contactForm.phone"></form-text>
        </form-item>
        <form-item>
            <form-label [label]="subtitle(6440)"></form-label>
            <form-text
                    [subtitle]="forms.contactForm.installerInformation"></form-text>
        </form-item>
    </form-section>
}

<form-section [subtitle]="subtitle(7469)">
    <service24-form></service24-form>
    <form-item>
        <app-link [subtitle]="subtitle(8419)"
                  (click)="appAlert.showDocumentPopup(subtitles.language, 'regulations');">
        </app-link>
    </form-item>
    <form-item>
        <app-link [subtitle]="subtitle(12665)"
                  (click)="appAlert.showDocumentPopup(subtitles.language, 'generalPolicy');">
        </app-link>
    </form-item>
    <form-item>
        <app-link [subtitle]="subtitle(12665)"
                  (click)="appAlert.showDocumentPopup(subtitles.language, 'policy');">
        </app-link>
    </form-item>
</form-section>

<form-section [subtitle]="'API'">
    <form-card-button [subtitle]="settingsAccount.generatingApiToken ? subtitle(17938) : subtitle(17939)"
                      (onClick)="generateApiToken()">
    </form-card-button>
</form-section>

@switch (settingsAccount.showDialog) {
    @case ('email') {
        <app-dialog [subtitle]="subtitle(3391)" (close)="closeDialog()">
            <email-form (close)="closeDialog()"></email-form>
        </app-dialog>
    }
    @case ('password') {
        <app-dialog [subtitle]="subtitle(1949)" (close)="closeDialog()">
            <password-form (close)="closeDialog()"></password-form>
        </app-dialog>
    }
    @case ('deleteAccount') {
        <app-dialog [subtitle]="subtitle(3806)" (close)="closeDialog()">
            <delete-account-form (close)="closeDialog()"></delete-account-form>
        </app-dialog>
    }
    @case ('additionalInfo') {
        <app-dialog [subtitle]="subtitle(2972)"
                    (close)="closeDialog()">
            <additional-info-form
                    (close)="closeDialog()"></additional-info-form>
        </app-dialog>
    }
    @case ('apiToken') {
        <app-dialog [subtitle]="subtitle(17940)"
                    (close)="closeDialog()">
            <api-token-form [token]="settingsAccount.apiToken"
                            (close)="closeDialog()"></api-token-form>
        </app-dialog>
    }
}
